export const GET_AUCTION = 'GET_AUCTION';
